import React from 'react';
import { twMerge } from 'tailwind-merge';
import HoverButton from '../buttons/HoverButton';
import QuestionCircleSvg from '../icons/QuestionCircleLight';

interface QuestionCircleProps {
  children: React.ReactNode;
  className?: string;
  arrowClassName?: string;
  buttonTextColor?: string;
  buttonBgColor?: string;
}

export default function QuestionCircle({
  children,
  className,
  arrowClassName,
  buttonTextColor,
  buttonBgColor,
}: QuestionCircleProps): JSX.Element {
  return (
    <HoverButton>
      <HoverButton.Button>
        <QuestionCircleSvg textColor={buttonTextColor} bgColor={buttonBgColor} />
      </HoverButton.Button>
      <HoverButton.Div
        className={twMerge(
          'rounded-[6px] bg-primary-900 px-3 py-2 text-sm text-secondary-50',
          className,
        )}>
        <div
          className={twMerge(
            'absolute h-[15px] w-[15px] rounded-[3px] bg-primary-900',
            arrowClassName || 'hidden',
          )}
        />
        {children}
      </HoverButton.Div>
    </HoverButton>
  );
}
